export interface VirtualScrollerConfig {
  itemsLimit: number
  installComponents?: boolean
  componentsPrefix?: string
}

const config: VirtualScrollerConfig = {
  itemsLimit: 1000,
}

export default config
